module.exports = __webpack_public_path__ + "img/send.8ff13721.svg";